import { render } from "./DebtDetail.vue?vue&type=template&id=93e4a9b2&scoped=true"
import script from "./DebtDetail.vue?vue&type=script&lang=js"
export * from "./DebtDetail.vue?vue&type=script&lang=js"

import "./DebtDetail.vue?vue&type=style&index=0&id=93e4a9b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e4a9b2"]])

export default __exports__